<template>
  <div class="container-fluid">
    <div
      v-if="label.title"
      class="row border-radius d-flex align-items-center bg-secondary-5 p-2"
    >
      <icon v-if="icon" class="mx-3" :i="icon.header" />
      <span>{{ label.title }}</span>
    </div>
    <div class="row m-4">
      <chip
        v-for="item in selectedItems"
        :key="item.label"
        :has-icon="false"
        :title="item.label"
      />
    </div>
    <div v-if="!readOnly" class="row d-flex justify-content-center">
      <open-btn v-if="!opened" :text="label.openMsg" @click="opened = true" />

      <div v-if="opened" class="col-12 mb-3 mt-2">
        <div v-if="icon.inside" class="ml-4">
          <em
            class="rounded-circle p-2 mr-2 color-green shadow bg-white"
            :class="icon.inside"
          />
          <span>{{ label.text }}</span>
        </div>

        <container
          v-model="listSelected"
          class="mt-3"
          :label="label.inner"
          :list-items="list.concat(selectedItems)"
        />

        <div class="row">
          <div class="col d-flex justify-content-end">
            <action-button
              class="mr-3"
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger"
              @click="opened = false"
            />
            <action-button
              i="fas fa-plus"
              text="Añadir"
              variant="success"
              @click="saveHandler"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon';
import OpenBtn from './OpenButton';
import Container from './Container';
import ActionButton from './../ActionButton';
import Chip from './Chip';
import mixAlert from '@/mixins/alert.mixin.js';

export default {
  name: 'WrapperMultiSelection',
  components: {
    Icon,
    OpenBtn,
    Container,
    ActionButton,
    Chip,
  },
  mixins: [mixAlert],
  props: {
    save: {
      type: Function,
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    label: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      opened: this.isOpen,
      listSelected: [],
    };
  },
  provide() {
    return {
      placeholder: this.label.placeholder,
    };
  },
  methods: {
    saveHandler() {
      if (!this.listSelected.length) {
        this.ShowToast(
          'Error',
          'Favor seleccionar al menos un municipio.',
          'error'
        );
        return;
      }

      this.save(this.listSelected);
      this.opened = false;
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 5px;
}
</style>
